import { render_sign } from "../functions";

export const modalWarningAudioRecord = {
    view: function (ctrl, args) {

        return m('div.dm-overlay',
            m("div.dm-table", [
                m("div.dm-cell", [
                    m("div.dm-modal", [
                        m(".bg-primary[style='padding:10px;z-index:1;']", [
                            m("span[id='modalTitle']", "[Title]"),
                            m("span.pull-right[style='cursor: pointer;']", {
                                onclick: modalContainerWarningAudioRecord.close
                            }, [
                                m("i.glyphicon.glyphicon-remove"),
                                m.trust('&nbsp;Закрыть')
                            ])
                        ]),
                        [
                            m("div", [
                                m("div[style='margin: 15px 0; padding: 0 15px;']", [
                                    m("div[style='']", [
                                        m("div[id='modalContent']", "[Content]"),
                                        m(".row[id='modalButtons'][style='display: flex; justify-content: space-around;']", [
                                            /*m(".col-xs-6",[
                                                m("button.btn.btn-success.btn-md", {
                                                    id: "yesBtnModalSignCheckList"
                                                }, "Сохранить")
                                            ]),
                                            m(".col-xs-6",[
                                                m("button.btn.btn-info.btn-md", {
                                                    id: "clear_sign",
                                                    onclick: function () {

                                                    }
                                                }, "Очистить")
                                            ])*/
                                        ]),
                                    ]),
                                ])
                            ])
                        ]
                    ])
                ])
            ])
        );
    }
};

export const modalContainerWarningAudioRecord = {
    container: null,
    idElement: null,
    init: function () {
        modalContainerWarningAudioRecord.container = document.querySelector('#modalWarning');
        if (!modalContainerWarningAudioRecord.container) {
            modalContainerWarningAudioRecord.container = document.createElement('div');
            modalContainerWarningAudioRecord.container.id = 'modalWarning';
            modalContainerWarningAudioRecord.container.hidden = true;
            document.body.appendChild(modalContainerWarningAudioRecord.container);

            m.mount(modalContainerWarningAudioRecord.container, m.component(modalWarningAudioRecord, {data:  "", type: false, idElement: ""}));
        }
    },
    open: function (title, message, buttons, idElement) {
        modalContainerWarningAudioRecord.container = document.querySelector('#modalWarning');
        if(typeof(idElement) != "undefined" && idElement !== null)
            modalContainerWarningAudioRecord.idElement = idElement;
        if(typeof(removeAll) != "undefined" && removeAll !== null)
            modalContainerWarningAudioRecord.removeAll = removeAll;

        if (modalContainerWarningAudioRecord.container) {
            if(title){
                document.getElementById("modalTitle").innerHTML = title;
            }
            if(message){
                document.getElementById("modalContent").innerHTML = message;
            }
            if(buttons){
                document.getElementById("modalButtons").innerHTML = "";
                document.getElementById("modalButtons").append(buttons);
            }
            //document.getElementById("titleModalSignCheckList").innerText = title;

            modalContainerWarningAudioRecord.container.hidden = false;
        }
    },
    close: function () {
        modalContainerWarningAudioRecord.container.hidden = true;
    }
};
